import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchMe, postMe } from '../../actions/communication';
import { LoadingSpinner } from '../helpers/LoadingSpinner';
import { useCommunication } from '../../hooks/useCommunication';

const SendingAs = ({ isLoading, meData, fetchMe, postMe }) => {
  const { newMessageModal } = useCommunication();
  const editableRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const isEditingRef = useRef(false);
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    fetchMe();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (editableRef.current && meData.me && !hasLoadedRef.current) {
      editableRef.current.textContent = meData.me;
      hasLoadedRef.current = true;
    }
  }, [meData.me]);

  const handleSave = () => {
    const value = editableRef.current?.textContent?.trim();
    if (!value) {
      editableRef.current.textContent = meData.me;
      setIsEditing(false);
      return;
    }
    if (value !== meData.me) {
      postMe({ communication: { sending_as: value } });
    }
    isEditingRef.current = false;
    setIsEditing(false);
    editableRef.current?.blur();
  };

  const handleCancel = () => {
    editableRef.current.textContent = meData.me;
    isEditingRef.current = false;
    setIsEditing(false);
    editableRef.current?.blur();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div className="row u-margin-top--base o-communication__container-from flex-container align-justify align-middle">
      <div className="flex-container align-middle" style={{flex: 1, justifyContent: 'space-between'}}>
      <div>
        <div className="o-communication__sending-as flex-container align-middle">
          <div className="u-txt--bold">From:&nbsp;</div>
          {isLoading && !hasLoadedRef.current ? <LoadingSpinner/> : (
            <span
              ref={editableRef}
              className="o-communication__sending-as--editable u-txt--bold"
              contentEditable
              suppressContentEditableWarning
              onFocus={() => { setIsEditing(true); isEditingRef.current = true; }}
              onKeyDown={handleKeyDown}
              spellCheck={false}
            />
          )}
          {!isEditing && (
            <i
              className="fa fa-pencil o-communication__sending-as--edit-hint"
              aria-hidden="true"
              style={{cursor: 'pointer'}}
              onClick={() => editableRef.current?.focus()}
            />
          )}
          {isEditing && (
            <>
              <button className="o-communication__sending-as--action-btn o-communication__sending-as--action-btn--confirm" onMouseDown={handleSave} title="Save">
                <i className="fa fa-check" aria-hidden="true"></i>
              </button>
              <button className="o-communication__sending-as--action-btn o-communication__sending-as--action-btn--cancel" onMouseDown={handleCancel} title="Cancel">
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </>
          )}
        </div>
        <div className="u-txt--label">
          The name seen by parent/caregiver(s) when they receive your message sent via Sparkler
        </div>
      </div>
      <button
        className="o-communication__new-message-btn"
        onClick={newMessageModal}
        title="New Message"
      >
        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
        <span>New Message</span>
      </button>
      </div>
    </div>
  );
};

SendingAs.propTypes = {
  fetchMe: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  meData: PropTypes.object.isRequired,
  postMe: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    meData: state.communicationMe?.data || {},
    isLoading: state.communicationMe?.loading || false,
  };
};

export default connect(mapStateToProps, { fetchMe, postMe })(SendingAs);
